import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import SearchBox from 'components/common/SearchBox';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { ChangeEvent, useEffect, useState } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { faFileExport, faPlus } from '@fortawesome/free-solid-svg-icons';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import AdvanceTable from 'components/base/AdvanceTable';
import { ColumnDef } from '@tanstack/react-table';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from 'components/common/ActionDropdownItems';
import { addService, deleteService, getService } from 'services/services';
import ConfirmationModal from 'components/modals/ConfirmationModal';
import { jsonToFormData, validationErrorFromAPI } from 'helpers/utils';
import { toast } from 'react-toastify';
import StageDropdownItems from 'components/common/StageDropdownItems';

interface Project {
  id: number;
  stage_name: any;
  count: number; // Assuming you want to count occurrences
}

interface Industry {
  id: number;
  name: string;
}

interface IndustryStage {
  id: number;
  stage_name: string;
  count: number; // Assuming you want to count occurrences
}

type EditAction = () => void;

const StageList = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState('');

  const [stageName, setStageName] = useState('');
  const [stageId, setStageId] = useState('');
  const [industryList, setIndustryList] = useState<Industry[]>([]);
  const [industryID, setIndustryID] = useState('');
  const [stageList, setStageList] = useState<IndustryStage[]>([]);
  const [role, setRole] = useState(0);

  useEffect(() => {
    if (localStorage.getItem('token')) {
      const role = Number(localStorage.getItem('role'));
      setRole(role);
    }
  }, []);

  const handleShow = (data: any) => {
    setShow(true);
    setStageId(data.id);
    setStageName(data.stage_name);
    setIndustryID(data.industry_id);
  };
  const confirmAlert = (id: any) => {
    setShowAlert(true);
    setStageId(id);
  };
  const removeApi = async () => {
    const response = await deleteService(`stage/${stageId}`);
    if (response?.status === 200) {
      toast.success('Remove SuccessFully', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light'
      });
      fetch();
      setShowAlert(false);
      setStageId('');
    }
  };

  const handleClose = () => {
    setShow(false);
    setStageId('');
    setStageName('');
    setIndustryID('');
    setError('');
  };

  const handleSave = async () => {
    if (stageName === '') {
      setError('Please enter an industry title.');
      return;
    } else {
      const data = jsonToFormData({ name: stageName, industry_id: industryID });
      let response: any = {};
      if (stageId) {
        response = await addService(`stage/${stageId}`, data);
      } else {
        response = await addService(`stage`, data);
      }
      if (response?.status === 200) {
        fetch();
        handleClose();
        toast.success('SuccessFully Added', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light'
        });
      } else if (response?.status === 500) {
        toast.error('Error', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light'
        });
        validationErrorFromAPI(response.data);
      }
    }
  };

  const fetch = async () => {
    const response = await getService('stage');
    if (response.status === 200) {
      // setStageList(response.data);
      const processApiResponse = (data: any[]): IndustryStage[] => {
        const industryMap = new Map<string, IndustryStage>(); // Use Map for efficient lookups

        for (const item of data) {
          const industryName = item.industry.name;
          const stageName = item.stage_name;

          if (!industryMap.has(industryName)) {
            industryMap.set(industryName, {
              id: 0,
              stage_name: industryName,
              count: 0
            });
          }

          const industryStage = industryMap.get(industryName)!;
          industryStage.count++; // Increment count for each stage in the industry
        }

        return Array.from(industryMap.values()); // Convert Map to array
      };

      // Assuming you have the API data in a variable called 'apiData'
      const processedData = processApiResponse(response.data);
      setStageList(processedData);
      // const result = response.data()
    } else if (response?.status === 500) {
      validationErrorFromAPI(response.data);
    }
  };
  useEffect(() => {
    fetch();
    fetchIndustry();
  }, []);

  const fetchIndustry = async () => {
    const response = await getService('industrie');
    if (response.status === 200) {
      setIndustryList(response.data);
    } else if (response?.status === 500) {
      validationErrorFromAPI(response.data);
    }
  };

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    table.setGlobalFilter(e.target.value || undefined);
  };

  const membersTablecolumns: ColumnDef<Project>[] = [
    {
      accessorKey: 'stage_name',
      header: 'Industry Name',
      cell: ({ row: { original } }) => {
        const { stage_name } = original;
        return (
          <Link to="#!" className=" d-flex align-items-center text-body">
            <p className="mb-0 ms-3 text-body-emphasis fw-semibold">
              {stage_name}
            </p>
          </Link>
        );
      },
      meta: {
        headerProps: { style: { width: '80%' } },
        cellProps: { className: 'text-body' }
      }
    },
    {
      accessorKey: 'count',
      header: 'No of Stages',
      meta: {
        headerProps: { style: { width: '20%' } },
        cellProps: { className: 'text-body' }
      }
    },
    {
      id: 'action',
      cell: ({ row: { original } }) => {
        const { id } = original;
        if (role === 1) {
          return (
            <RevealDropdownTrigger>
              <RevealDropdown>
                <StageDropdownItems
                  detailsAction={() => navigate('/stage')}
                  // removeAction={() => confirmAlert(id)}
                />
              </RevealDropdown>
            </RevealDropdownTrigger>
          );
        } else {
          return null;
        }
      },
      meta: {
        headerProps: { style: { width: '10%' }, className: 'text-end' },
        cellProps: { className: 'text-end' }
      }
    }
  ];

  const table = useAdvanceTable({
    data: stageList,
    columns: membersTablecolumns,
    pageSize: 10,
    pagination: true,
    sortable: true,
    selection: true
  });

  return (
    <div>
      {showAlert && (
        <ConfirmationModal
          name={'Stage'}
          show={showAlert}
          handleClose={() => setShowAlert(false)}
          handleAction={() => removeApi()}
        />
      )}
      <div className="mb-9">
        <h3 className="mb-5 text-uppercase">Stage dashboard</h3>

        <AdvanceTableProvider {...table}>
          <div className="mb-4">
            <Row className="g-3">
              <Col xs="auto">
                <SearchBox
                  placeholder="Search members"
                  onChange={handleSearchInputChange}
                />
              </Col>
              <Col
                xs="auto"
                className="scrollbar overflow-hidden-y flex-grow-1"
              ></Col>
              <Col xs="auto">
                <Button variant="link" className="text-body me-4 px-0">
                  <FontAwesomeIcon icon={faFileExport} className="fs-9 me-2" />
                  Export
                </Button>
                {role === 1 && (
                  <Button
                    onClick={handleShow}
                    variant="primary"
                    className="px-5"
                  >
                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                    Add Stage
                  </Button>
                )}
              </Col>
            </Row>
          </div>
          <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
            <MembersTable />
          </div>
          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>{stageId ? 'Edit' : 'Create'} stage</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group controlId="exampleForm.ControlSelect1">
                  <Form.Label>Select Industries</Form.Label>
                  <Form.Select
                    value={industryID}
                    onChange={e => setIndustryID(e.target.value)}
                  >
                    <option>Select Industries</option>
                    {industryList.length > 0 &&
                      industryList.map(industry => (
                        <option key={industry.id} value={industry.id}>
                          {industry.name}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Add stage</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter stage"
                    autoFocus
                    value={stageName}
                    onChange={e => {
                      setStageName(e.target.value);
                      setError('');
                    }}
                    isInvalid={error !== ''}
                  />
                  <Form.Control.Feedback type="invalid">
                    {error}
                  </Form.Control.Feedback>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button variant="primary" onClick={handleSave}>
                Save Changes
              </Button>
            </Modal.Footer>
          </Modal>
        </AdvanceTableProvider>
      </div>
    </div>
  );
};

export const MembersTable = () => {
  return (
    <div>
      <AdvanceTable tableProps={{ className: 'phoenix-table fs-9' }} />
      <AdvanceTableFooter pagination />
    </div>
  );
};

export default StageList;
